import French from 'Images/localization/french.png'
import Japanese from 'Images/localization/japanese.png'
import Korean from 'Images/localization/korean.png'
import Chinese from 'Images/localization/chinese.png'
import Russian from 'Images/localization/russian.png'
import Ukrainian from 'Images/localization/ukrainian.png'
import Spanish from 'Images/localization/spanish.png'
import Portuguese from 'Images/localization/portuguese.png'
import Arabic from 'Images/localization/arabic.png'
import Italian from 'Images/localization/italian.png'
import Turkish from 'Images/localization/turkish.png'
import English from 'Images/localization/english.png'
import Polish from 'Images/localization/polish.png'

export const SOCIAL_SSO = {
  google: 'google',
  clever: 'clever',
}

export const STD_ONBOARDING_PATH = {
  basename: '/students',
  root: '/',
  login: '/login',
  signup: '/signup',
}

export const LOC_LIST = [
  {
    lang: 'english',
    copy: 'English',
    flag: English,
  },
  {
    lang: 'french',
    copy: 'Français',
    flag: French,
  },
  {
    lang: 'japanese',
    copy: '日本語',
    flag: Japanese,
  },
  {
    lang: 'korean',
    copy: '한국어',
    flag: Korean,
  },
  {
    lang: 'chinese',
    copy: '中文',
    flag: Chinese,
  },
  {
    lang: 'russian',
    copy: 'Русский',
    flag: Russian,
  },
  {
    lang: 'ukrainian',
    copy: 'Українська',
    flag: Ukrainian,
  },
  {
    lang: 'spanish',
    copy: 'Español',
    flag: Spanish,
  },
  {
    lang: 'portuguese',
    copy: 'Português',
    flag: Portuguese,
  },
  {
    lang: 'arabic',
    copy: 'العربية',
    flag: Arabic,
  },
  {
    lang: 'italian',
    copy: 'Italiano',
    flag: Italian,
  },
  {
    lang: 'turkish',
    copy: 'Türkçe',
    flag: Turkish,
  },
  {
    lang: 'polish',
    copy: 'Polski',
    flag: Polish,
  },
]

export const SIGNUP_ERROR_MESSAGE = {
  existingUsernameError: 'Existing: This username is already in use',
  invalidCodeError: 'Invalid invitation code',
  teacherReachedTheLimit:
    'Sorry, this class is full! Please talk to your teacher.',
  generalError: 'We’re sorry. Something went wrong. Please try again',
}
